// only data returned from severino has this format, all others are returned on TimestampInMillis UTC-0
export const severinoDateFormat = 'YYYY-MM-DD HH:mm';

export default severinoDateFormat;
